import script from "./FrmMassiveRecordsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./FrmMassiveRecordsNew.vue?vue&type=script&setup=true&lang=js"

import "./FrmMassiveRecordsNew.vue?vue&type=style&index=0&id=564231f5&lang=scss"

const __exports__ = script;

export default __exports__